export const leaf = {
    leafLightest: '#e8f5eb',
    leafLight: '#b0ddba',
    leaf: '#61bc76',
    leafDark: '#23764c',
    leafDarkest: '#054f31',
};
